import {
  Box,
  Button,
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { masterplanVm } from "../../../data/c4/masterplan.data";
import { DownArrow } from "../../../icons";
import hqPin from "../data/hqPins.data";
import usePanoramaPins from "../hooks/usePanoramaPins";
import usePanoramaPopupStore from "../stores/usePanoramaPopupStore";
import useSelectedMenuStore from "../stores/useSelectedMenuStore";
import useViewerStore from "../stores/useViewerStore";

const backgroundStyle = {
  borderRadius: "5px",
  border: "solid 1px white",
  marginBottom: "8px",
};

const options = [
  {
    label: "default view",
    phase: {
      position: [-3052400.056859965, 4043103.349480272, 3867396.740176105] as [
        number,
        number,
        number,
      ],
      orientation: {
        heading: 0.35310931692087877,
        pitch: -1.5429339140156002,
        roll: 0.0,
      },
    },
  },
  ...masterplanVm.items.map((item) => ({
    label: item.name,
    phase: item.phase,
  })),
];
// .push();

const MasterPlanMenu = () => {
  const { selectedMenu, setSelectedMenu } = useSelectedMenuStore();
  const { closePopup } = usePanoramaPopupStore();
  const { setPhase } = useViewerStore();
  const toggleDropdown = () => {
    closePopup();
    if (selectedMenu === "KSS") {
      setSelectedMenu("NOTHING");
    } else {
      setSelectedMenu("KSS");
      setPhase(options[0].phase);
    }
  };

  const [option, setOption] = useState("default view");

  React.useEffect(() => {
    const selectedOption = options.find((item) => item.label === option);
    if (selectedOption) {
      setPhase(selectedOption.phase);
    }
  }, [option, setPhase]);

  const [isOpen, setIsOpen] = React.useState(false);

  React.useEffect(() => {
    const notDefaultView = option !== "default view";
    if (selectedMenu === "KSS" && notDefaultView) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [selectedMenu, option]);

  usePanoramaPins({ items: hqPin, show: isOpen });

  return (
    <Box sx={backgroundStyle}>
      <Button
        sx={{
          padding: "0px",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          width: "100%",
          color: selectedMenu === "KSS" ? "yellow" : "white",
        }}
        onClick={toggleDropdown}
      >
        <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
          <Typography
            sx={{
              size: "14px",
              lineHeight: "22px",
              letterSpacing: "-0.43px",
              fontWeight: "700",
            }}
          >
            K-Seongsu Master plan
          </Typography>
          <DownArrow
            sx={{ marginLeft: "auto", width: "30px", height: "30px" }}
          />
        </Box>
        <Typography sx={{ fontSize: "10px" }}>(2024.08)</Typography>
      </Button>
      {selectedMenu === "KSS" && (
        <Box>
          <FormControl size="small" sx={{ m: 1, minWidth: 224 }}>
            <Select
              id="demo-select-small"
              sx={{
                fontSize: "10px",
                padding: "0px",
                color: "white",
                borderRadius: "5px",
                border: "solid 0.3px",
              }}
              value={option}
              onChange={(event: SelectChangeEvent<string>) => {
                setOption(event.target.value);
                console.log(event.target.value);
              }}
            >
              {/* <MenuItem defaultChecked key={0} value={"default view"}>
                default view
              </MenuItem> */}

              {options.map((item) => (
                <MenuItem key={item.label} value={item.label}>
                  {item.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      )}
    </Box>
  );
};

export default MasterPlanMenu;
